import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { addExtraReducer } from '../../../../store/addExtraReducer'
import { LoadingStatusEnum } from '../../../../store/types'
import { SortDirectionCapital } from '../../../../types'
import { UsersPagination } from '../api/types'

import initialState from './initialState'
import { GetUsersReducer } from './reducers'
import { SLICE_NAME, GetUsers } from './thunks'

const UsersSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    // updateColumnOrder: (state, action) => {
    //   state.pagination.columns = action.payload
    // },
    updatePageSize: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.perPage = action.payload
    },
    updatePage: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = action.payload
    },
    updateOrderBy: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.order = SortDirectionCapital.asc
      state.pagination.orderBy = action.payload
    },
    updateSortOrder: (state, action) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.order = action.payload
    },
    updateSearch: (state, action: PayloadAction<string>) => {
      state.loading = LoadingStatusEnum.Pending
      state.pagination.page = 1
      state.pagination.search = action.payload
    },
    updateFilters: (state, action: PayloadAction<Partial<UsersPagination>>) => {
      state.loading = LoadingStatusEnum.Pending
      Object.assign(state.pagination, action.payload)
      state.pagination.page = 1
    },
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetUsers, GetUsersReducer)
  },
})

export const {
  updatePageSize,
  updatePage,
  updateOrderBy,
  updateSortOrder,
  updateSearch,
  updateFilters,
} = UsersSlice.actions

export default UsersSlice.reducer
